import { getAspectRatio } from "./getAspectRatio";

export const calculateCanvasImageDimensions = (
    imageWidth: number,
    imageHeight: number,
    containerWidth: number,
    containerHeight: number,
    willRotate: boolean,
): {
    width: number;
    height: number;
} => {
    const originalWidth = imageWidth;
    const originalHeight = imageHeight;

    let height = originalHeight;
    let width = originalWidth;

    const ratio = getAspectRatio(originalWidth, originalHeight);
    const ratioWidth = Number(ratio.split(":")[0]) ?? 1;
    const ratioHeight = Number(ratio.split(":")[1]) ?? 1;

    if (originalHeight > containerHeight) {
        height = containerHeight;
        width = (ratioWidth / ratioHeight) * height;
    }

    if (width > containerWidth) {
        width = containerWidth;
        height = (ratioHeight / ratioWidth) * width;
    }

    /* 
     see if rotated image overflows out of container
     if yes reduce the size of the image so that it fits
    */
    //  that means it will overflow once rotated
    if (width > containerHeight && willRotate) {
        width = containerHeight;
        height = (ratioHeight / ratioWidth) * width;
    }

    if (height > containerWidth && willRotate) {
        height = width;
        width = (ratioWidth / ratioHeight) * height;
    }

    return {
        width,
        height,
    };
};
